module.exports = __webpack_public_path__ + "img/DSC_2746-xs.8377d33a.png";